(function($) {
  let modalSlider = null;
  let modalOpening = false;
  let currentZoomImage = null;
  let isZoomed = false;
  const ZOOM_SCALE = 1.8;
  let isScrolling = false;
  let scrollTimer = null;

  $(function() {
    // Scroll interne => suspend le hover zoom inline
    $('.main-slider-wrapper').on('scroll', function() {
      isScrolling = true;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => { isScrolling = false; }, 160);
    });

    bindInlineHoverZoom();
    bindGlobalModalEvents();
    bindPinchZoom();
  });

  function bindGlobalModalEvents() {
    // Ouverture (mobile only)
    $(document).on('click', '.product-image-modal-trigger', function(e) {
      e.preventDefault();
      // Only open modal on mobile devices (screen width <= 768px)
      if (window.innerWidth <= 768) {
        var clickedSrc = $(this).data('modal-image') || $(this).attr('src');
        openImageModal(clickedSrc);
      }
    });

    // Toolbar
    $(document)
      .on('click', '#modal-close', closeImageModal)
      .on('click', '#modal-overlay', closeImageModal)
      .on('click', '#modal-zoom-toggle', function() {
        toggleZoom(getActiveSlideImage());
      });

    // Clavier
    $(document).on('keydown.modalNav', function(e) {
      if (e.key === 'Escape') return closeImageModal();
      if (!$('#product-image-modal').is(':visible')) return;
      if (e.key === 'ArrowRight') slickGo(1);
      if (e.key === 'ArrowLeft') slickGo(-1);
      if (e.key === 'z') $('#modal-zoom-toggle').trigger('click');
    });

    // Wheel zoom (délégué, sans options objet)
    $(document).off('wheel.modalZoom').on('wheel.modalZoom', '#product-image-modal .modal-main-image', function(e) {
      if (!isZoomed) return;
      e.preventDefault();
      const delta = Math.sign(e.originalEvent.deltaY);
      const img = $(this);
      let current = parseFloat(img.data('z') || ZOOM_SCALE);
      current += delta * -0.2;
      current = Math.min(Math.max(1, current), 5);
      img.data('z', current);

      // Keep current pan position
      const m = img.data('pan') || {x:0,y:0};
      img.css('transform', `scale(${current}) translate(${m.x / current}px, ${m.y / current}px)`);

      // Reset if zoomed out completely
      if (current <= 1.1) {
        resetZoomState();
      }
    });
  }

  /* Click zoom inline hors modal */
  function bindInlineHoverZoom() {
    $(document)
      .off('.inlineZoom')
      .on('click.inlineZoom', '.slide', function(e) {
        if (isScrolling) return;
        
        const $slide = $(this);
        const $img = $slide.children('img');
        const isCurrentlyZoomed = $slide.hasClass('inline-zoomed');
        
        // Reset all other zoomed slides first
        $('.slide.inline-zoomed').removeClass('inline-zoomed')
          .children('img').css({ 
            transform: 'scale(1)', 
            'transform-origin': 'center center' 
          });
        
        if (!isCurrentlyZoomed) {
          // Apply zoom to clicked slide
          const scale = parseFloat($slide.attr('data-scale')) || 1.3;
          $slide.addClass('inline-zoomed');
          $img.css({
            transform: 'scale(' + scale + ')',
            'transform-origin': 'center center'
          });
        }
      })
      .on('mousemove.inlineZoom', '.slide.inline-zoomed', function(e) {
        // Only apply mouse tracking for already zoomed images
        const $slide = $(this);
        const $img = $slide.children('img');
        const scale = parseFloat($slide.attr('data-scale')) || 1.3;
        const off = $slide.offset();
        const x = ((e.pageX - off.left) / $slide.width()) * 100;
        const y = ((e.pageY - off.top) / $slide.height()) * 100;
        $img.css({
          transform: 'scale(' + scale + ')',
          'transform-origin': x + '% ' + y + '%'
        });
      })
      .on('mouseleave.inlineZoom', '.slide.inline-zoomed', function() {
        // Reset zoom when mouse leaves the image
        const $slide = $(this);
        const $img = $slide.children('img');
        $slide.removeClass('inline-zoomed');
        $img.css({ 
          transform: 'scale(1)', 
          'transform-origin': 'center center' 
        });
      });
  }

  /* Pinch-to-zoom pour mobile */
  function bindPinchZoom() {
    // Variables pour le pinch
    let initialDistance = 0;
    let initialScale = 1;
    let currentScale = 1;
    let isPinching = false;
    let pinchStarted = false;

    // Variables pour le pan
    let isPanning = false;
    let panStartX = 0;
    let panStartY = 0;
    let translateX = 0;
    let translateY = 0;
    let savedTransformOrigin = 'center center';

    // Function to reset all zoomed images
    function resetAllZoom() {
      console.log('[Zoom] Resetting all zoom');
      $('.slide.inline-zoomed').each(function() {
        const $slide = $(this);
        const $img = $slide.children('img');

        $slide.removeClass('inline-zoomed');
        $img.css({
          transform: 'scale(1)',
          'transform-origin': 'center center',
          transition: 'transform 0.3s ease-out',
          'will-change': '',
          '-webkit-backface-visibility': '',
          'backface-visibility': '',
          '-webkit-perspective': '',
          'perspective': '',
          '-webkit-transform-style': '',
          'transform-style': ''
        });

        // Show zoom button in non-zoomed state
        hideZoomButton($slide);
      });

      // Re-enable Slick slider when zoom is reset
      const $imageMain = $('.image-main');
      if ($imageMain.length && $imageMain.hasClass('slick-initialized')) {
        console.log('[Zoom] Re-enabling Slick slider in resetAllZoom');
        $imageMain.slick('slickSetOption', 'swipe', true, false);
        $imageMain.slick('slickSetOption', 'draggable', true, false);
        $imageMain.slick('slickSetOption', 'touchMove', true, false);
      }

      // Reset state
      currentScale = 1;
      translateX = 0;
      translateY = 0;
      savedTransformOrigin = 'center center';
      isPanning = false;
      isPinching = false;
    }

    // Function to disable Slick when image is zoomed
    function disableSlickForZoom() {
      const $imageMain = $('.image-main');
      if ($imageMain.length && $imageMain.hasClass('slick-initialized')) {
        $imageMain.slick('slickSetOption', 'swipe', false, false);
        $imageMain.slick('slickSetOption', 'draggable', false, false);
        $imageMain.slick('slickSetOption', 'touchMove', false, false);
      }
    }

    // Function removed - no initial buttons shown

    // Function to show zoom-out button (only when zoomed)
    function showZoomButton($slide) {
      console.log('[Zoom] Showing zoom-out button');

      // Remove any existing button first
      $slide.find('.zoom-btn-wrapper').remove();

      // Make sure slide has position: relative for absolute positioning to work
      $slide.css('position', 'relative');

      // Always show zoom-out icon (button only appears when zoomed)
      const zoomOutUrl = window.zoomIconAssets ? window.zoomIconAssets.zoomOut : '/assets/zoom-out.svg';
      const iconSrc = zoomOutUrl;

      const $button = $(`
        <div class="zoom-btn-wrapper" style="
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 1000;
          pointer-events: auto;
        ">
          <button class="zoom-toggle-btn" style="
            background: rgba(255, 255, 255, 0.9);
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            width: 40px;
            height: 40px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            padding: 8px;
          " title="Zoom out">
            <img src="${iconSrc}" alt="Zoom out" style="width: 100%; height: 100%;" class="zoom-icon-img" />
          </button>
        </div>
      `);

      $slide.append($button);

      // Zoom-out button handler (only zooms out)
      $button.find('.zoom-toggle-btn').on('click touchend', function(e) {
        e.stopPropagation();
        e.preventDefault();

        // Check if already handled (prevent double-firing on touch devices)
        if (e.type === 'touchend' && $(this).data('handling')) {
          return;
        }
        $(this).data('handling', true);
        setTimeout(() => $(this).data('handling', false), 300);

        const $img = $slide.children('img');
        console.log('[Zoom] Zoom-out button clicked, currentScale:', currentScale);

        // Always zoom out to 1x and hide button
        currentScale = 1;
        translateX = 0;
        translateY = 0;
        isPanning = false;
        isPinching = false;
        $slide.removeClass('inline-zoomed');

        // Reset image transform completely
        $img.css({
          transform: 'scale(1)',
          'transform-origin': 'center center',
          transition: 'transform 0.3s ease-out',
          'will-change': '',
          '-webkit-backface-visibility': '',
          'backface-visibility': '',
          '-webkit-perspective': '',
          'perspective': '',
          '-webkit-transform': 'scale(1)',
          '-webkit-transform-style': '',
          'transform-style': '',
          'touch-action': ''
        });

        // Hide the button
        hideZoomButton($slide);

        // Re-enable Slick slider
        const $imageMain = $('.image-main');
        if ($imageMain.length && $imageMain.hasClass('slick-initialized')) {
          console.log('[Zoom] Re-enabling Slick slider after zoom out');
          $imageMain.slick('slickSetOption', 'swipe', true, false);
          $imageMain.slick('slickSetOption', 'draggable', true, false);
          $imageMain.slick('slickSetOption', 'touchMove', true, false);
        }
      });
    }

    // Function to hide zoom button
    function hideZoomButton($slide) {
      console.log('[Zoom] Hiding zoom button');
      // Remove zoom button from the slide
      if ($slide) {
        $slide.find('.zoom-btn-wrapper').remove();
      } else {
        $('.zoom-btn-wrapper').remove();
      }
    }

    // Reset zoom when Slick slider changes (swipe/drag)
    // Only reset if the zoom change was initiated by slider movement, not by user interaction
    $('.image-main').on('beforeChange.zoomReset', function(event, slick, currentSlide, nextSlide) {
      console.log('[Zoom] Slider about to change - resetting zoom');
      // Only reset if not currently pinching or panning
      if (!isPinching && !isPanning) {
        resetAllZoom();
      }
    });

    function getDistance(touches) {
      const touch1 = touches[0];
      const touch2 = touches[1];
      const dx = touch2.clientX - touch1.clientX;
      const dy = touch2.clientY - touch1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function getCenter(touches) {
      const touch1 = touches[0];
      const touch2 = touches[1];
      return {
        x: (touch1.clientX + touch2.clientX) / 2,
        y: (touch1.clientY + touch2.clientY) / 2
      };
    }

    // Variables for tap detection
    let tapStartTime = 0;
    let tapStartX = 0;
    let tapStartY = 0;

    // Gestion du pinch sur les slides
    $(document)
      .off('.pinchZoom')
      .on('touchstart.pinchZoom', '.slide img', function(e) {
        const touches = e.originalEvent.touches;

        // Store tap start info for tap detection
        if (touches.length === 1) {
          tapStartTime = Date.now();
          tapStartX = touches[0].clientX;
          tapStartY = touches[0].clientY;
        }

        // Two-finger pinch
        if (touches.length === 2) {
          e.preventDefault();
          e.stopPropagation(); // Stop event from reaching Slick
          isPinching = true;
          pinchStarted = true;
          isPanning = false; // Stop any ongoing pan

          // Disable Slick slider immediately
          disableSlickForZoom();

          initialDistance = getDistance(touches);

          const $img = $(this);
          const currentTransform = $img.css('transform');
          if (currentTransform && currentTransform !== 'none') {
            const matrix = currentTransform.match(/matrix\\((.+)\\)/);
            if (matrix) {
              const values = matrix[1].split(',');
              currentScale = parseFloat(values[0]) || 1;
            }
          } else {
            currentScale = 1;
          }
          initialScale = currentScale;
        }
        // Single-finger touch on zoomed image - prepare for panning
        else if (touches.length === 1) {
          const $img = $(this);
          const $slide = $img.closest('.slide');

          // Check if image is zoomed (either by pinch or by click)
          if ($slide.hasClass('inline-zoomed')) {
            e.preventDefault(); // Prevent scrolling
            e.stopPropagation(); // Stop event from reaching Slick
            $img.css('touch-action', 'none'); // Disable browser touch gestures

            // Disable Slick slider immediately when starting to pan
            disableSlickForZoom();

            // Read the current scale and transform-origin
            const currentTransform = $img.css('transform');
            if (currentTransform && currentTransform !== 'none') {
              const matrixMatch = currentTransform.match(/matrix(?:3d)?\\(([^)]+)\\)/);
              if (matrixMatch) {
                const values = matrixMatch[1].split(',').map(v => parseFloat(v.trim()));
                // Scale is the first value in the matrix
                currentScale = values[0] || 1;
              }
            }

            // Save the current transform-origin set by click zoom
            const origin = $img.css('transform-origin');
            if (origin) {
              savedTransformOrigin = origin;
            }

            isPanning = true;
            panStartX = touches[0].clientX;
            panStartY = touches[0].clientY;
            // Reset translate for fresh start if this is first pan after click zoom
            if (translateX === 0 && translateY === 0) {
              translateX = 0;
              translateY = 0;
            }
          }
        }
      })
      .on('touchmove.pinchZoom', '.slide img', function(e) {
        const touches = e.originalEvent.touches;

        // Pan mode avec un seul doigt sur image zoomée
        if (touches.length === 1 && isPanning && !isPinching && currentScale > 1) {
          e.preventDefault();
          e.stopPropagation();

          const deltaX = touches[0].clientX - panStartX;
          const deltaY = touches[0].clientY - panStartY;

          translateX += deltaX;
          translateY += deltaY;

          // Apply pan boundaries
          const $img = $(this);
          const $container = $img.parent();
          const containerWidth = $container.width();
          const containerHeight = $container.height();

          // Get actual displayed image dimensions (not natural size)
          const img = this;
          const displayedWidth = img.offsetWidth || img.clientWidth;
          const displayedHeight = img.offsetHeight || img.clientHeight;

          // Calculate scaled dimensions based on displayed size
          const scaledWidth = displayedWidth * currentScale;
          const scaledHeight = displayedHeight * currentScale;

          // Calculate max pan distance - image can only pan by the overflow amount
          const overflowX = Math.max(0, scaledWidth - containerWidth);
          const overflowY = Math.max(0, scaledHeight - containerHeight);

          const maxPanX = overflowX / 2;
          const maxPanY = overflowY / 2;

          // Constrain translation
          translateX = Math.max(-maxPanX, Math.min(maxPanX, translateX));
          translateY = Math.max(-maxPanY, Math.min(maxPanY, translateY));

          panStartX = touches[0].clientX;
          panStartY = touches[0].clientY;

          // Use requestAnimationFrame for smoother panning
          requestAnimationFrame(() => {
            $img.css({
              transform: `scale(${currentScale}) translate(${translateX / currentScale}px, ${translateY / currentScale}px)`,
              'transform-origin': savedTransformOrigin,
              transition: 'none',
              'will-change': 'transform',
              '-webkit-backface-visibility': 'hidden',
              'backface-visibility': 'hidden',
              '-webkit-perspective': '1000',
              'perspective': '1000',
              '-webkit-transform': `scale(${currentScale}) translate(${translateX / currentScale}px, ${translateY / currentScale}px)`,
              '-webkit-transform-style': 'preserve-3d',
              'transform-style': 'preserve-3d'
            });
          });

          return;
        }

        // Pinch-to-zoom avec deux doigts
        if (touches.length === 2 && isPinching) {
          e.preventDefault();

          const distance = getDistance(touches);
          let scale = (distance / initialDistance) * initialScale;

          // Rendre le zoom moins sensible/intense
          const sensitivity = 0.4;
          const normalizedScale = 1 + ((scale - 1) * sensitivity);

          // Limiter le zoom entre 1x et 2.5x
          currentScale = Math.min(Math.max(normalizedScale, 1), 2.5);

          const $img = $(this);
          const $slide = $img.closest('.slide');

          if (currentScale > 1) {
            $slide.addClass('inline-zoomed');

            // Show zoom button (zoomed state)
            showZoomButton($slide);

            // Disable Slick slider when zoomed
            disableSlickForZoom();

            // Apply pan boundaries during pinch
            const $container = $img.parent();
            const containerWidth = $container.width();
            const containerHeight = $container.height();

            const img = this;
            const displayedWidth = img.offsetWidth || img.clientWidth;
            const displayedHeight = img.offsetHeight || img.clientHeight;

            const scaledWidth = displayedWidth * currentScale;
            const scaledHeight = displayedHeight * currentScale;

            const overflowX = Math.max(0, scaledWidth - containerWidth);
            const overflowY = Math.max(0, scaledHeight - containerHeight);

            const maxPanX = overflowX / 2;
            const maxPanY = overflowY / 2;

            // Constrain translation
            translateX = Math.max(-maxPanX, Math.min(maxPanX, translateX));
            translateY = Math.max(-maxPanY, Math.min(maxPanY, translateY));

            // Calculer le centre du pinch relativement à l'image
            const center = getCenter(touches);
            const imgRect = this.getBoundingClientRect();
            const originX = ((center.x - imgRect.left) / imgRect.width) * 100;
            const originY = ((center.y - imgRect.top) / imgRect.height) * 100;

            // Use requestAnimationFrame for smoother rendering
            requestAnimationFrame(() => {
              $img.css({
                transform: `scale(${currentScale}) translate(${translateX / currentScale}px, ${translateY / currentScale}px)`,
                'transform-origin': `${originX}% ${originY}%`,
                transition: 'none',
                'will-change': 'transform',
                '-webkit-backface-visibility': 'hidden',
                'backface-visibility': 'hidden',
                '-webkit-perspective': '1000',
                'perspective': '1000',
                '-webkit-transform': `scale(${currentScale}) translate(${translateX / currentScale}px, ${translateY / currentScale}px)`,
                '-webkit-transform-style': 'preserve-3d',
                'transform-style': 'preserve-3d'
              });
            });
          } else {
            console.log('[Zoom] Pinch zoomed out to scale < 1, resetting to 1');
            $slide.removeClass('inline-zoomed');
            translateX = 0;
            translateY = 0;
            currentScale = 1;
            $img.css({
              transform: 'scale(1)',
              'transform-origin': 'center center',
              transition: 'transform 0.2s ease-out',
              'will-change': '',
              '-webkit-backface-visibility': '',
              'backface-visibility': '',
              '-webkit-perspective': '',
              'perspective': '',
              '-webkit-transform': 'scale(1)',
              '-webkit-transform-style': '',
              'transform-style': '',
              'touch-action': ''
            });

            // Show zoom button in non-zoomed state
            hideZoomButton($slide);

            // Re-enable Slick when zoom returns to 1
            const $imageMain = $('.image-main');
            if ($imageMain.length && $imageMain.hasClass('slick-initialized')) {
              console.log('[Zoom] Re-enabling Slick after pinch zoom out');
              $imageMain.slick('slickSetOption', 'swipe', true, false);
              $imageMain.slick('slickSetOption', 'draggable', true, false);
              $imageMain.slick('slickSetOption', 'touchMove', true, false);
            }
          }
        }
      })
      .on('touchend.pinchZoom touchcancel.pinchZoom', '.slide img', function(e) {
        const touches = e.originalEvent.changedTouches;

        // Detect tap to unzoom (check tap even if isPanning/isPinching were set)
        if (touches.length === 1) {
          const tapEndTime = Date.now();
          const tapEndX = touches[0].clientX;
          const tapEndY = touches[0].clientY;

          const tapDuration = tapEndTime - tapStartTime;
          const tapDistanceX = Math.abs(tapEndX - tapStartX);
          const tapDistanceY = Math.abs(tapEndY - tapStartY);
          const tapDistance = Math.sqrt(tapDistanceX * tapDistanceX + tapDistanceY * tapDistanceY);

          // More lenient tap detection: longer duration and bigger distance allowed
          if (tapDuration < 400 && tapDistance < 20) {
            const $img = $(this);
            const $slide = $img.closest('.slide');

            if ($slide.hasClass('inline-zoomed') && !isPinching) {
              console.log('[Zoom] Tap detected on zoomed image - unzooming (duration:', tapDuration, 'distance:', tapDistance, ')');

              // Reset zoom
              $slide.removeClass('inline-zoomed');
              $img.css({
                transform: 'scale(1)',
                'transform-origin': 'center center',
                transition: 'transform 0.3s ease-out',
                'touch-action': '',
                'will-change': '',
                '-webkit-backface-visibility': '',
                'backface-visibility': '',
                '-webkit-perspective': '',
                'perspective': '',
                '-webkit-transform': 'scale(1)',
                '-webkit-transform-style': '',
                'transform-style': ''
              });

              currentScale = 1;
              translateX = 0;
              translateY = 0;
              savedTransformOrigin = 'center center';

              // Show zoom button in non-zoomed state
              hideZoomButton($slide);

              // Re-enable Slick slider
              const $imageMain = $('.image-main');
              if ($imageMain.length && $imageMain.hasClass('slick-initialized')) {
                $imageMain.slick('slickSetOption', 'swipe', true, false);
                $imageMain.slick('slickSetOption', 'draggable', true, false);
                $imageMain.slick('slickSetOption', 'touchMove', true, false);
                console.log('[Zoom] Slick slider re-enabled after tap');
              }

              // Reset panning state
              isPanning = false;
              isPinching = false;

              return; // Exit early, don't process other touch end logic
            }
          }
        }

        if (isPinching) {
          isPinching = false;

          const $img = $(this);
          const $slide = $img.closest('.slide');

          // Si le zoom est très proche de 1, on reset complètement
          if (currentScale < 1.15) {
            console.log('[Zoom] Touchend - scale < 1.15, resetting to 1');
            $slide.removeClass('inline-zoomed');
            $img.css({
              transform: 'scale(1)',
              'transform-origin': 'center center',
              transition: 'transform 0.3s ease-out',
              'touch-action': '', // Re-enable default touch behavior
              '-webkit-transform': 'scale(1)'
            });
            currentScale = 1;
            translateX = 0;
            translateY = 0;
            savedTransformOrigin = 'center center';
            isPanning = false;
            isPinching = false;

            // Show zoom button in non-zoomed state
            hideZoomButton($slide);

            // Re-enable Slick when zoom is reset
            const $imageMain = $('.image-main');
            if ($imageMain.length && $imageMain.hasClass('slick-initialized')) {
              console.log('[Zoom] Re-enabling Slick after touchend reset');
              $imageMain.slick('slickSetOption', 'swipe', true, false);
              $imageMain.slick('slickSetOption', 'draggable', true, false);
              $imageMain.slick('slickSetOption', 'touchMove', true, false);
            }
          } else {
            // Sinon on garde le zoom mais on ajoute une transition
            $img.css({
              transition: 'transform 0.2s ease-out'
            });

            // Show zoom button since we're still zoomed
            showZoomButton($slide);
          }

          // Empêcher le click après un pinch
          if (pinchStarted) {
            setTimeout(() => { pinchStarted = false; }, 150);
          }
        }

        // Always reset panning state at the end
        if (isPanning) {
          console.log('[Zoom] Resetting isPanning flag');
          isPanning = false;
        }
        if (isPinching) {
          console.log('[Zoom] Resetting isPinching flag (fallback)');
          isPinching = false;
        }
      });

    // Empêcher le click zoom après un pinch ou pan
    $(document).on('click.pinchZoom', '.slide', function(e) {
      if (pinchStarted || isPanning) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    });

    // Double-tap pour reset zoom
    let lastTap = 0;
    $(document).on('touchend.pinchZoom', '.slide', function(e) {
      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;

      if (tapLength < 500 && tapLength > 0 && !pinchStarted) {
        e.preventDefault();

        const $slide = $(this);
        const $img = $slide.children('img');

        // Reset zoom sur double-tap
        $slide.removeClass('inline-zoomed');
        $img.css({
          transform: 'scale(1)',
          'transform-origin': 'center center',
          transition: 'transform 0.3s ease-out',
          'touch-action': ''
        });
        currentScale = 1;
        translateX = 0;
        translateY = 0;
        savedTransformOrigin = 'center center';

        // Supprimer la transition après l'animation
        setTimeout(() => {
          $img.css('transition', '');
        }, 300);
      }

      lastTap = currentTime;
    });
  }

  function collectImages() {
    const arr = [];
    const seenUrls = new Set(); // Track seen URLs to avoid duplicates
    let visibleIndex = 0;
    let skippedClones = 0;
    let skippedHidden = 0;
    let skippedColor = 0;
    let skippedDuplicates = 0;

    // Get the currently active color
    const activeColor = $('.swatch-element.active-swatch').attr('data-colorname-value');
    console.log('[Modal] Active color:', activeColor);

    // Only select images that are NOT inside Slick cloned slides
    $('.product-image-modal-trigger').each(function(i) {
      const $img = $(this);
      const $slide = $img.closest('.slide');

      // Skip Slick cloned slides (from the main page slider)
      if ($slide.length && $slide.hasClass('slick-cloned')) {
        skippedClones++;
        return; // Skip cloned slides
      }

      // Skip if the slide is hidden
      if ($slide.length) {
        // Check if slide is hidden by display:none
        if ($slide.css('display') === 'none' || !$slide.is(':visible')) {
          skippedHidden++;
          return; // Skip hidden slides
        }

        // If there's an active color filter, only include matching color images
        if (activeColor) {
          const slideColor = ($slide.attr('data-color') || $slide.data('color') || '').toString();
          const slideColorLower = slideColor.toLowerCase();
          const activeColorLower = activeColor.toLowerCase();

          if (slideColor && slideColorLower !== activeColorLower) {
            skippedColor++;
            return; // Skip non-matching color
          }
        }
      }

      // Final visibility check
      if ($img.is(':visible')) {
        const src = $img.data('modal-image') || $img.attr('src');

        // Skip duplicate URLs
        if (seenUrls.has(src)) {
          skippedDuplicates++;
          console.log('[Modal] Skipping duplicate:', src);
          return;
        }

        seenUrls.add(src);
        console.log('[Modal] Adding image', visibleIndex + 1, ':', src);
        arr.push({
          src: src,
          alt: $img.attr('alt') || '',
          idx: visibleIndex
        });
        visibleIndex++;
      }
    });

    console.log('[Modal] Collected', arr.length, 'unique images for color:', activeColor || 'all');
    console.log('[Modal] Skipped:', skippedClones, 'clones,', skippedHidden, 'hidden,', skippedColor, 'wrong color,', skippedDuplicates, 'duplicates');
    return arr;
  }

  function openImageModal(clickedSrc) {
    if (modalOpening) return;
    modalOpening = true;

    const images = collectImages();
    if (!images.length) {
      modalOpening = false;
      return;
    }

    // Find the correct slide index by matching the clicked image src
    let startIndex = 0;
    if (clickedSrc) {
      for (let i = 0; i < images.length; i++) {
        if (images[i].src === clickedSrc) {
          startIndex = i;
          break;
        }
      }
    }

    const $modal = $('#product-image-modal');
    if (!$modal.length) {
      modalOpening = false;
      return;
    }
    const $slider = $modal.find('.modal-slider');

    // Reset
    resetZoomState();
    $('#modal-zoom-toggle').attr('aria-pressed', 'false');

    if (modalSlider && $slider.hasClass('slick-initialized')) {
      try { $slider.slick('unslick'); } catch(e) {}
    }

    const html = images.map(img => `
      <div class="modal-slide" data-index="${img.idx}">
        <img src="${img.src}" alt="${escapeHtml(img.alt)}" class="modal-main-image" draggable="false" />
      </div>`).join('');
    $slider.html(html);

    $modal.addClass('active').fadeIn(160).attr('aria-hidden','false').removeAttr('inert');
    $('body').addClass('modal-open');

    setTimeout(() => {
      initSlick($slider, startIndex, images.length);
      modalOpening = false;
    }, 40);
  }

  function initSlick($slider, startIndex, total) {
    try {
      modalSlider = $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 380,
        cssEase: 'cubic-bezier(.4,0,.2,1)',
        initialSlide: startIndex,
        responsive: [{ breakpoint: 768, settings: { arrows: false } }]
      });

      $('#modal-total-count').text(total);
      updateCounter();

      $slider.on('afterChange', function() {
        resetZoomState();
        updateCounter();
      });

      // Tap / click image => zoom toggle
      $slider.on('click', '.modal-main-image', function(e) {
        if ($(e.target).closest('.slick-arrow').length) return;
        toggleZoom($(this));
      });

    } catch(err) {
      console.error('[Modal] init slick error', err);
    }
  }

  function slickGo(delta) {
    if (!modalSlider) return;
    $('.modal-slider').slick('slick' + (delta > 0 ? 'Next' : 'Prev'));
  }

  function updateCounter() {
    const $current = $('.modal-slider .slick-current');
    if (!$current.length) return;
    const rawIndex = parseInt($current.attr('data-slick-index'), 10);
    // Only count original slides, not clones created by Slick infinite mode
    const total = $('.modal-slider .modal-slide:not(.slick-cloned)').length;
    const logical = ((rawIndex % total) + total) % total; // wrap
    $('#modal-current-index').text(logical + 1);
  }

  function getActiveSlideImage() {
    return $('.modal-slider .slick-current .modal-main-image');
  }

  function toggleZoom($img) {
    if (!$img || !$img.length) return;
    const $btn = $('#modal-zoom-toggle');
    if (!isZoomed) {
      const $slide = $img.closest('.modal-slide');
      $slide.addClass('zoomed');
      $img.css({
        'transform-origin': 'center center',
        transform: `scale(${ZOOM_SCALE})`,
        'touch-action': 'none' // Disable browser touch gestures
      }).data('z', ZOOM_SCALE);
      currentZoomImage = $img;
      isZoomed = true;
      $btn.attr('aria-pressed','true').addClass('is-zoomed');
      // Enable pan for both mobile and desktop
      enablePan($img);
    } else {
      resetZoomState();
    }
  }

  function resetZoomState() {
    if (currentZoomImage) {
      currentZoomImage.closest('.modal-slide').removeClass('zoomed');
      currentZoomImage.css({
        transform: 'scale(1) translate(0,0)',
        'transform-origin': 'center center',
        'touch-action': '' // Re-enable default touch behavior
      }).data('z',1).removeData('pan');
    }
    currentZoomImage = null;
    isZoomed = false;
    $('#modal-zoom-toggle').attr('aria-pressed','false').removeClass('is-zoomed');
    disablePan();
  }

  function enablePan($img) {
    let startX=0,startY=0,imgStartX=0,imgStartY=0,isDragging=false;
    let isPinching=false,initialDistance=0,initialScale=1;
    const ns = '.zoomPan';

    function getDistance(touches) {
      const dx = touches[1].clientX - touches[0].clientX;
      const dy = touches[1].clientY - touches[0].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    $img.off(ns).on('mousedown'+ns+' touchstart'+ns, function(e) {
      const touches = e.originalEvent?.touches;

      // Two-finger pinch
      if (touches && touches.length === 2) {
        e.preventDefault();
        e.stopPropagation();
        isPinching = true;
        isDragging = false;
        initialDistance = getDistance(touches);
        initialScale = parseFloat($img.data('z') || ZOOM_SCALE);

        // Disable slider immediately on pinch
        const $slider = $img.closest('.modal-slider');
        if ($slider.length && $slider.hasClass('slick-initialized')) {
          $slider.slick('slickSetOption', 'swipe', false, false);
          $slider.slick('slickSetOption', 'draggable', false, false);
          $slider.slick('slickSetOption', 'touchMove', false, false);
        }
        return;
      }

      // Single-finger touch/mouse
      const evt = e.type.startsWith('touch') ? e.originalEvent.touches[0] : e;
      startX = evt.clientX;
      startY = evt.clientY;
      const m = $img.data('pan') || {x:0,y:0};
      imgStartX = m.x;
      imgStartY = m.y;

      // For mouse events OR touch on zoomed image, enable dragging immediately
      if (!e.type.startsWith('touch') || parseFloat($img.data('z') || 1) > 1.5) {
        isDragging = true;
        isPinching = false;
        $('body').addClass('grabbing');
        e.preventDefault();
        e.stopPropagation();

        const $slider = $img.closest('.modal-slider');
        if ($slider.length && $slider.hasClass('slick-initialized')) {
          $slider.slick('slickSetOption', 'swipe', false, false);
          $slider.slick('slickSetOption', 'draggable', false, false);
          $slider.slick('slickSetOption', 'touchMove', false, false);
        }
      }
    });

    $(document).off(ns).on('mousemove'+ns+' touchmove'+ns, function(e) {
      const touches = e.originalEvent?.touches;

      // Handle pinch zoom
      if (isPinching && touches && touches.length === 2) {
        e.preventDefault();
        e.stopPropagation();

        const distance = getDistance(touches);
        let newScale = (distance / initialDistance) * initialScale;

        // Limit zoom between 1x and 5x
        newScale = Math.min(Math.max(newScale, 1), 5);

        $img.data('z', newScale);

        // Keep current pan position with boundaries
        let m = $img.data('pan') || {x:0,y:0};

        // Apply boundaries during pinch
        if (newScale > 1) {
          const img = $img[0];
          const imgRect = img.getBoundingClientRect();
          const $container = $img.closest('.modal-slide');
          const containerWidth = $container.width();
          const containerHeight = $container.height();

          const scaledWidth = imgRect.width / parseFloat($img.data('z') || 1) * newScale;
          const scaledHeight = imgRect.height / parseFloat($img.data('z') || 1) * newScale;
          const maxPanX = Math.max(0, (scaledWidth - containerWidth) / 2);
          const maxPanY = Math.max(0, (scaledHeight - containerHeight) / 2);

          m.x = Math.max(-maxPanX, Math.min(maxPanX, m.x));
          m.y = Math.max(-maxPanY, Math.min(maxPanY, m.y));
          $img.data('pan', m);
        }

        // Use requestAnimationFrame for smoothness
        requestAnimationFrame(() => {
          $img.css({
            transform: `scale(${newScale}) translate(${m.x / newScale}px, ${m.y / newScale}px)`,
            transition: 'none',
            'will-change': 'transform',
            '-webkit-backface-visibility': 'hidden',
            'backface-visibility': 'hidden'
          });
        });
        return;
      }

      // Handle single-finger pan
      if (!isDragging || isPinching) return;

      e.preventDefault();
      e.stopPropagation();

      const evt = e.type.startsWith('touch') ? e.originalEvent.touches[0] : e;
      const dx = evt.clientX - startX;
      const dy = evt.clientY - startY;
      let nx = imgStartX + dx;
      let ny = imgStartY + dy;

      const z = parseFloat($img.data('z') || ZOOM_SCALE);

      // Apply pan boundaries for modal
      if (z > 1) {
        const img = $img[0];
        const imgRect = img.getBoundingClientRect();
        const $container = $img.closest('.modal-slide');
        const containerWidth = $container.width();
        const containerHeight = $container.height();

        // Calculate max pan distance based on zoom
        const scaledWidth = imgRect.width / z * z;
        const scaledHeight = imgRect.height / z * z;
        const maxPanX = Math.max(0, (scaledWidth - containerWidth) / 2);
        const maxPanY = Math.max(0, (scaledHeight - containerHeight) / 2);

        // Constrain translation
        nx = Math.max(-maxPanX, Math.min(maxPanX, nx));
        ny = Math.max(-maxPanY, Math.min(maxPanY, ny));
      }

      $img.data('pan', {x:nx,y:ny});

      // Use requestAnimationFrame for smooth panning
      requestAnimationFrame(() => {
        $img.css({
          transform: `scale(${z}) translate(${nx / z}px, ${ny / z}px)`,
          'will-change': 'transform',
          '-webkit-backface-visibility': 'hidden',
          'backface-visibility': 'hidden'
        });
      });
    });

    $(document).on('mouseup'+ns+' touchend'+ns+' touchcancel'+ns, function(e) {
      const wasPinching = isPinching;
      const wasDragging = isDragging;

      if (wasPinching) {
        isPinching = false;

        // Add smooth transition after pinch ends
        $img.css({
          transition: 'transform 0.2s ease-out',
          'will-change': ''
        });
        setTimeout(() => {
          $img.css('transition', '');
        }, 200);

        // Check if zoomed out completely
        const currentScale = parseFloat($img.data('z') || 1);
        if (currentScale <= 1.1) {
          // Reset zoom completely
          resetZoomState();
        }
      }

      if (wasDragging) {
        isDragging = false;
        $('body').removeClass('grabbing');
        $img.css('will-change', '');
      }

      // Re-enable Slick slider swiping after interaction - but only if not heavily zoomed
      if (wasPinching || wasDragging) {
        const currentZoom = parseFloat($img.data('z') || 1);
        const $slider = $img.closest('.modal-slider');
        if ($slider.length && $slider.hasClass('slick-initialized')) {
          // Only re-enable slider if zoom is close to 1x
          if (currentZoom < 1.5) {
            setTimeout(() => {
              $slider.slick('slickSetOption', 'swipe', true, false);
              $slider.slick('slickSetOption', 'draggable', true, false);
              $slider.slick('slickSetOption', 'touchMove', true, false);
            }, 100);
          }
        }
      }
    });
  }

  function disablePan() {
    $(document).off('.zoomPan');
    $('body').removeClass('grabbing');

    // Re-enable Slick slider swiping when pan is disabled
    const $slider = $('.modal-slider');
    if ($slider.length && $slider.hasClass('slick-initialized')) {
      setTimeout(() => {
        $slider.slick('slickSetOption', 'swipe', true, false);
        $slider.slick('slickSetOption', 'draggable', true, false);
        $slider.slick('slickSetOption', 'touchMove', true, false);
      }, 50);
    }
  }

  function closeImageModal() {
    const $modal = $('#product-image-modal');
    if (!$modal.is(':visible')) return;
    try {
      if (modalSlider && $modal.find('.modal-slider').hasClass('slick-initialized')) {
        $modal.find('.modal-slider').slick('unslick');
      }
    } catch(e) {}
    modalSlider = null;
    resetZoomState();
    $modal.fadeOut(150, () => {
      $modal.removeClass('active').attr('aria-hidden','true').attr('inert','');
      $('body').removeClass('modal-open');
    });
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, c => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
    }[c]));
  }

})(jQuery);